<template>
    <div class="animated fadeIn">
      <b-button
        type="button"
        size="sm"
        variant="success"
        v-show="'created' === membership.status"
        v-b-modal.sendMailModal
        :disabled="disabled"
      ><i class="fa fa-money" ></i> Pay
      </b-button>
      <membership-send-mail-modal @click="onModalClick"></membership-send-mail-modal>
    </div>
</template>
<script>
    import {Membership} from "../../../models/Membership"
    import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";
    import {handleErrors} from "../../../shared/utils";
    import MembershipSendMailModal from "../MembershipSendMailModal";

    const MembershipRepo = RepositoryFactory.get('membership');

    export default {
        name: 'membership-button-pay',
        components: {
            MembershipSendMailModal,
        },
        props: {
            membership: {
                type: Object,
                default: new Membership(),
            },
        },
        data() {
            return {
                disabled: false,
                sendMail: true,
            }
        },
        methods: {
            payMembership() {
                this.disabled = true
                MembershipRepo
                    .payMembership(this.membership.id, this.sendMail)
                    .then(
                        response =>
                            (
                                this.$emit('paid', response.data.data),
                                this.disabled = false
                            )
                    )
                    .catch(
                        response => (
                            this.returnErrors(response)
                        )
                    )
            },
            onModalClick(state){
                this.$emit('click')
                this.sendMail = state
                this.payMembership()
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                )
                this.disabled = false
                this.$emit('click')
            },
        },
    }
</script>
